import { NgModule } from "@angular/core";

import { ReportDashboardRoutingModule } from "./report-dashboard-routing.module";
import { ReportDashboardComponent } from "./report-dashboard.component";

import { NgxEchartsModule } from "ngx-echarts";
import { SharedModule } from "../../shared/shared.module";
import * as echarts from 'echarts';


@NgModule({
  declarations: [ReportDashboardComponent],
  imports: [
    NgxEchartsModule.forRoot({
      echarts: () => import("echarts"),
    }),
    ReportDashboardRoutingModule,
    SharedModule,
  ],
})
export class ReportDashboardModule {}
